import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {InternalRoutes} from '../../models/internal-routes';
import { LogoNexiaComponent } from '../logo-nexia/component/logo-nexia.component';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: true,
    imports: [LogoNexiaComponent]
})
export class ErrorComponent implements OnInit, OnDestroy {

  InternalRoutes = InternalRoutes;
  error: any;
  subs = [];

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.subs.push(this.activeRoute.queryParams.subscribe(
      () => {
        if (this.error) {
          console.error('ErrorComponent: ', this.error);
        }
      }
    ));
  }

  ngOnDestroy() {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }

  backToHome() {
    this.router.navigate([''], {replaceUrl: true});
  }
}
